import {TouristicSiteCardPremium} from "../touristicSiteCardPremium";
import React from "react";

const TouristicSiteElementPremium = ({openTsModal, el}) => {
  return (
    <div className="roadtrip-elements py-2">
      <div className="roadtrip-element" style={{opacity: 1}}>
        <div className="roadtrip-element__obj">
          <TouristicSiteCardPremium openTsModal={openTsModal}  touristicSite={el} roadTripPage={true}/>
        </div>
      </div>
    </div>
  )
}

export default TouristicSiteElementPremium;